/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CancelQuoteDto = {
    /**
     * Reason for quote cancellation
     */
    reason: CancelQuoteDto.reason;
};
export namespace CancelQuoteDto {
    /**
     * Reason for quote cancellation
     */
    export enum reason {
        AUTO_LAPSED_BY_RENEWAL_MANAGER = 'AUTO LAPSED BY RENEWAL MANAGER',
        BROKER_LOST_ACCOUNT = 'BROKER LOST ACCOUNT',
        DECLINED_BY_ANDO = 'DECLINED BY ANDO',
        DUPLICATED = 'DUPLICATED',
        INSURED_ELSEWHERE_PREMIUM = 'INSURED ELSEWHERE - PREMIUM',
        INSURED_ELSEWHERE_UNKNOWN = 'INSURED ELSEWHERE - UNKNOWN',
        RENEWAL_NOT_OFFERED_BY_ANDO_ = 'RENEWAL NOT OFFERED (BY ANDO)',
        REPLACED_BY_NEW_POLICY = 'REPLACED BY NEW POLICY',
        SOLD = 'SOLD',
    }
}

